import { render, staticRenderFns } from "./ImportStatusReasonsForm.vue?vue&type=template&id=71a3b3f5&"
import script from "./ImportStatusReasonsForm.vue?vue&type=script&lang=ts&"
export * from "./ImportStatusReasonsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ImportStatusReasonsForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports